import * as React from "react";
import { SVGProps } from "react";
const SvgBo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 512 336"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none">
      <path
        d="M0 223.908h512v102.988a8.829 8.829 0 0 1-8.828 8.828H8.828A8.829 8.829 0 0 1 0 326.896V223.908z"
        fill="#73AF00"
      />
      <path
        d="M8.828.276h494.345a8.829 8.829 0 0 1 8.828 8.828v102.988H0V9.104A8.829 8.829 0 0 1 8.828.276z"
        fill="#FF4B55"
      />
      <path fill="#FFE15A" d="M0 112.088h511.999V223.9H0z" />
      <path
        d="m244.598 117.957-.653.817a26.011 26.011 0 0 0-1.47 2.254c-1.145 1.999-2.347 5.098-2.38 8.792-.012 1.801.36 3.988.974 5.727.666 1.92 1.771 3.756 3.168 5.396 1.399 1.655 3.268 2.931 5.267 3.873.991.503 2.079.792 3.158 1.058.535.163 1.105.171 1.654.279.276.052.562.029.841.051l.422.019.211.011.105.006.053.003.026.001c-.085.003.227-.004-.184.007.684-.04 1.514-.045 2.078-.114.492-.115.906-.095 1.47-.262 1.08-.266 2.167-.555 3.158-1.058 1.998-.942 3.868-2.218 5.267-3.873 1.397-1.64 2.502-3.476 3.168-5.396.638-1.953.979-3.822.974-5.736-.031-3.678-1.234-6.788-2.379-8.785a23.374 23.374 0 0 0-1.494-2.276l-.607-.776-.053-.067a1.116 1.116 0 0 1 1.482-1.629l.937.6c.578.434 1.474 1.047 2.439 2.039 1.937 1.918 4.451 5.334 5.358 10.298.449 2.376.498 5.25-.121 8.075-.6 2.854-1.817 5.805-3.782 8.387-1.93 2.594-4.523 4.888-7.606 6.435-1.521.811-3.176 1.4-4.874 1.81-.814.239-1.847.338-2.767.483-.862.095-1.475.097-2.226.15l-.292.001-.082-.004-.164-.008-.328-.017-.657-.035c-.437-.035-.876-.029-1.309-.104-.863-.152-1.741-.223-2.583-.466-1.698-.409-3.354-.999-4.874-1.81-3.083-1.547-5.676-3.842-7.606-6.435-1.964-2.583-3.181-5.534-3.782-8.387-.642-3.04-.562-5.596-.12-8.084.905-4.949 3.421-8.377 5.357-10.291.961-.988 1.86-1.607 2.463-2.061l.89-.559a1.124 1.124 0 0 1 1.473 1.661z"
        fill="#73AF00"
      />
      <path
        d="M253.782 205.866v13.971c0 1.394-1.685 2.092-2.67 1.107l-.769-.769a3.405 3.405 0 0 1-.998-2.408v-11.901h4.437z"
        fill="#FF4B55"
      />
      <path
        d="M247.126 203.648v10.141c0 .609.242 1.194.673 1.625l1.545 1.545v-13.311h-2.218z"
        fill="#FFE15A"
      />
      <path
        d="M244.908 203.648v5.442c0 .777.309 1.522.857 2.071l1.361 1.361v-8.874h-2.218z"
        fill="#73AF00"
      />
      <path
        d="M258.218 205.866v13.971c0 1.394 1.685 2.092 2.67 1.107l.769-.769a3.405 3.405 0 0 0 .998-2.408v-11.901h-4.437z"
        fill="#FF4B55"
      />
      <path
        d="M264.873 203.648v10.141c0 .609-.242 1.194-.673 1.625l-1.545 1.545v-13.311h2.218z"
        fill="#FFE15A"
      />
      <path
        d="M267.092 203.648v5.442c0 .777-.309 1.522-.857 2.071l-1.361 1.361v-8.874h2.218z"
        fill="#73AF00"
      />
      <path
        d="m267.092 163.715 24.403-17.748v36.498c0 10.474-8.491 18.964-18.964 18.964-3.554 0-7.037-.999-10.051-2.882l-13.135-8.21v-26.93l17.747.308z"
        fill="#FF4B55"
      />
      <path
        d="M282.621 152.422v25.607c0 10.474-8.491 18.964-18.964 18.964-1.575 0-3.127-.227-4.64-.61l-9.673-6.046v-26.93l17.748.308 15.529-11.293z"
        fill="#FFE15A"
      />
      <path
        d="M275.966 157.261v16.531c0 10.474-8.491 18.964-18.964 18.964-1.575 0-3.128-.227-4.64-.61l-3.018-1.886v-26.853l17.748.308 8.874-6.454z"
        fill="#73AF00"
      />
      <path fill="#F5F5F5" d="m292.826 141.974 9.762-4.88-7.1 8.873h-3.993z" />
      <path
        d="m280.403 174.807 24.403-17.748v36.498c0 10.474-8.491 18.964-18.964 18.964-3.554 0-7.037-.999-10.051-2.882l-13.135-8.21v-26.93l17.747.308z"
        fill="#FF4B55"
      />
      <path
        d="M289.277 168.354v16.531c0 10.474-8.491 18.964-18.964 18.964-1.575 0-3.127-.227-4.64-.61l-3.018-1.886V174.5l17.748.308 8.874-6.454z"
        fill="#73AF00"
      />
      <path fill="#F5F5F5" d="m306.137 153.066 9.762-4.881-7.1 8.874h-3.993z" />
      <path
        d="m273.747 170.37 24.403-17.748v36.498c0 10.474-8.491 18.964-18.964 18.964-3.554 0-7.037-.999-10.051-2.882L256 196.992v-26.93l17.747.308z"
        fill="#FF4B55"
      />
      <path
        d="M289.277 159.076v25.607c0 10.474-8.491 18.964-18.964 18.964-1.575 0-3.127-.227-4.64-.61l-9.674-6.045v-26.93l17.748.308 15.53-11.294z"
        fill="#FFE15A"
      />
      <path
        d="M282.621 163.917v16.531c0 10.474-8.491 18.964-18.964 18.964-1.575 0-3.127-.227-4.64-.61l-3.018-1.885v-26.853l17.748.308 8.874-6.455z"
        fill="#73AF00"
      />
      <path fill="#F5F5F5" d="m299.482 148.629 9.761-4.881-7.1 8.874h-3.992z" />
      <path
        d="m244.908 163.715-24.403-17.748v36.498c0 10.474 8.491 18.964 18.964 18.964 3.554 0 7.037-.999 10.051-2.882l13.135-8.21v-26.93l-17.747.308z"
        fill="#FF4B55"
      />
      <path
        d="M229.378 152.422v25.607c0 10.474 8.491 18.964 18.964 18.964 1.575 0 3.127-.227 4.64-.61l9.673-6.046v-26.93l-17.748.308-15.529-11.293z"
        fill="#FFE15A"
      />
      <path
        d="M236.034 157.261v16.531c0 10.474 8.491 18.964 18.964 18.964 1.575 0 3.128-.227 4.64-.61l3.018-1.886v-26.853l-17.748.308-8.874-6.454z"
        fill="#73AF00"
      />
      <path fill="#F5F5F5" d="m219.173 141.974-9.761-4.88 7.1 8.873h3.992z" />
      <path
        d="m231.597 174.807-24.403-17.748v36.498c0 10.474 8.491 18.964 18.964 18.964 3.554 0 7.037-.999 10.051-2.882l13.135-8.21v-26.93l-17.747.308z"
        fill="#FF4B55"
      />
      <path
        d="M222.723 168.354v16.531c0 10.474 8.491 18.964 18.964 18.964 1.575 0 3.127-.227 4.64-.61l3.018-1.886V174.5l-17.748.308-8.874-6.454z"
        fill="#73AF00"
      />
      <path fill="#F5F5F5" d="m205.862 153.066-9.761-4.881 7.1 8.874h3.992z" />
      <path
        d="m238.252 170.37-24.403-17.748v36.498c0 10.474 8.491 18.964 18.964 18.964 3.554 0 7.037-.999 10.051-2.882l13.135-8.21v-26.93l-17.747.308z"
        fill="#FF4B55"
      />
      <path
        d="M222.723 159.076v25.607c0 10.474 8.491 18.964 18.964 18.964 1.575 0 3.127-.227 4.64-.61l9.673-6.046v-26.93l-17.748.308-15.529-11.293z"
        fill="#FFE15A"
      />
      <path
        d="M229.378 163.917v16.531c0 10.474 8.491 18.964 18.964 18.964 1.575 0 3.127-.227 4.64-.61l3.018-1.886v-26.853l-17.748.308-8.874-6.454z"
        fill="#73AF00"
      />
      <g transform="translate(222 148)" fill="#FFBE5A">
        <path d="m4.947 55.354-2.925-2.925a4.438 4.438 0 0 1 .106-6.378L50.545.555 56.82 6.83 11.324 55.247a4.434 4.434 0 0 1-6.377.107z" />
        <circle cx={3.489} cy={53.887} r={2.218} />
      </g>
      <ellipse
        fill="#F5F5F5"
        transform="rotate(-45 275.687 151.69)"
        cx={275.687}
        cy={151.689}
        rx={2.218}
        ry={4.436}
      />
      <g transform="translate(233 148)" fill="#FFBE5A">
        <path d="m52.052 55.354 2.925-2.925a4.438 4.438 0 0 0-.106-6.378L6.454.555.179 6.83l45.496 48.417a4.434 4.434 0 0 0 6.377.107z" />
        <circle cx={53.51} cy={53.887} r={2.218} />
      </g>
      <ellipse
        fill="#F5F5F5"
        transform="rotate(45 236.326 151.694)"
        cx={236.326}
        cy={151.694}
        rx={2.218}
        ry={4.436}
      />
      <ellipse
        fill="#FFBE5A"
        cx={255.999}
        cy={178.141}
        rx={19.616}
        ry={23.294}
      />
      <path
        fill="#FF4B55"
        d="m255.999 157.059 1.042 4.52 2.387-3.977-.407 4.62 3.499-3.044-1.814 4.268 4.268-1.814-3.045 3.499 4.62-.407-3.976 2.387 4.519 1.041-4.519 1.041 3.976 2.387-4.62-.406 3.045 3.497-4.268-1.813 1.814 4.268-3.499-3.044.407 4.619-2.387-3.976-1.042 4.519-1.04-4.519-2.387 3.976.406-4.619-3.498 3.044 1.813-4.268-4.267 1.813 3.044-3.497-4.619.406 3.975-2.387-4.518-1.041 4.518-1.041-3.975-2.387 4.619.407-3.044-3.499 4.267 1.814-1.813-4.268 3.498 3.044-.406-4.62 2.387 3.977z"
      />
      <path
        d="M280.541 177.719s-7.349 1.941-12.132-2.08c-5.316-4.469-9.302-6.579-11.01-7.371a2.154 2.154 0 0 0-1.825-.001c-1.224.565-3.476 1.736-5.468 3.49-2.912 2.566-11.855 7.626-13.657 7.626v11.029l14.073 12.196 16.639-.486 13.38-24.403z"
        fill="#73AF00"
      />
      <path
        d="M255.999 206.975c-14.068 0-25.513-12.938-25.513-28.84s11.444-28.84 25.513-28.84 25.513 12.938 25.513 28.84-11.445 28.84-25.513 28.84zm0-51.025c-10.398 0-18.857 9.953-18.857 22.185s8.459 22.185 18.857 22.185 18.857-9.953 18.857-22.185-8.459-22.185-18.857-22.185z"
        fill="#3CC8FF"
      />
      <path
        d="m252.177 200.946.489 1.465 1.545.012c.2.001.282.257.122.375l-1.242.918.466 1.473a.208.208 0 0 1-.32.232l-1.257-.898-1.257.898a.209.209 0 0 1-.32-.232l.466-1.473-1.242-.918a.208.208 0 0 1 .122-.375l1.545-.012.489-1.465a.207.207 0 0 1 .394 0zm-6.935-2.981.489 1.465 1.545.012c.2.001.282.257.122.375l-1.242.918.466 1.473a.208.208 0 0 1-.32.232l-1.257-.898-1.257.898a.209.209 0 0 1-.32-.232l.466-1.473-1.242-.918a.208.208 0 0 1 .122-.375l1.545-.012.489-1.465a.207.207 0 0 1 .394 0zm-5.569-5.061.489 1.465 1.545.012c.2.001.282.257.122.375l-1.242.918.466 1.473a.208.208 0 0 1-.32.232l-1.257-.898-1.257.898a.209.209 0 0 1-.32-.232l.466-1.473-1.242-.918a.208.208 0 0 1 .122-.375l1.545-.012.489-1.465a.207.207 0 0 1 .394 0zm-3.798-6.737.489 1.465 1.545.012c.2.001.282.257.122.375l-1.242.918.466 1.473a.208.208 0 0 1-.32.232l-1.257-.898-1.257.898a.209.209 0 0 1-.32-.232l.466-1.473-1.242-.918a.208.208 0 0 1 .122-.375l1.545-.012.489-1.465a.207.207 0 0 1 .394 0zm-1.676-7.833.489 1.465 1.545.012c.2.001.282.257.122.375l-1.242.918.466 1.473a.208.208 0 0 1-.32.232l-1.257-.898-1.257.898a.209.209 0 0 1-.32-.232l.466-1.473-1.242-.918a.208.208 0 0 1 .122-.375l1.545-.012.489-1.465c.062-.19.331-.19.394 0zm25.613 22.612-.489 1.465-1.545.012a.208.208 0 0 0-.122.375l1.242.918-.466 1.473a.208.208 0 0 0 .32.232l1.257-.898 1.257.898a.209.209 0 0 0 .32-.232l-.466-1.473 1.242-.918a.208.208 0 0 0-.122-.375l-1.545-.012-.489-1.465a.207.207 0 0 0-.394 0zm6.935-2.981-.489 1.465-1.545.012c-.2.001-.282.257-.122.375l1.242.918-.466 1.473a.208.208 0 0 0 .32.232l1.257-.898 1.257.898a.209.209 0 0 0 .32-.232l-.466-1.473 1.242-.918a.208.208 0 0 0-.122-.375l-1.545-.012-.489-1.465a.207.207 0 0 0-.394 0zm5.569-5.061-.489 1.465-1.545.012c-.2.001-.282.257-.122.375l1.242.918-.466 1.473a.208.208 0 0 0 .32.232l1.257-.898 1.257.898a.209.209 0 0 0 .32-.232l-.466-1.473 1.242-.918a.208.208 0 0 0-.122-.375l-1.545-.012-.489-1.465c-.062-.19-.331-.19-.394 0zm3.798-6.737-.489 1.465-1.545.012c-.2.001-.282.257-.122.375l1.242.918-.466 1.473a.208.208 0 0 0 .32.232l1.257-.898 1.257.898a.209.209 0 0 0 .32-.232l-.466-1.473 1.242-.918a.208.208 0 0 0-.122-.375l-1.545-.012-.489-1.465a.207.207 0 0 0-.394 0zm1.676-7.833-.489 1.465-1.545.012c-.2.001-.282.257-.122.375l1.242.918-.466 1.473a.208.208 0 0 0 .32.232l1.257-.898 1.257.898a.209.209 0 0 0 .32-.232l-.466-1.473 1.242-.918a.208.208 0 0 0-.122-.375l-1.545-.012-.489-1.465c-.062-.19-.33-.19-.394 0z"
        fill="#FFBE5A"
      />
      <path
        d="m246.361 192.357.737 3.526h.318v-2.406s.524 1.678 1.266 2.406h.6c-.287-.369-.803-1.134-.803-1.927 0-1.091.868-1.24.868-2.407h.744v4.333h.435l.806-3.861s.664 2.415 1.914 3.861h.556c-.401-.589-1.234-2.109-1.081-4.407 0 0 1.191-.596 1.191-2.208v-2.294c0-.429.349-.778.778-.778h.535s-.796-1.544-1.647-1.768v-.968l-.641.969c-.612.132-.973.698-.973 1.304v1.397a.778.778 0 0 1-.778.778h-2.781c-.823 0-2.142.823-2.142 1.878s.791 1.747.791 1.747l-.693.825z"
        fill="#F5F5F5"
      />
      <path
        d="M258.819 188.844h-.255c-2.016.11-3.142 1.436-3.142 1.436l2.045 2.045v3.848h2.447v-3.848l2.045-2.045c.001-.001-1.124-1.326-3.14-1.436z"
        fill="#FFBE5A"
      />
      <g fill="#F5F5F5">
        <path d="M263.117 182.554h1v13.634h-1z" />
        <path d="m263.511 182.445-3.987 4.819s-.52-2.323 1.803-4.61l-5.13.936s1.56-2.912 5.65-2.6l-4.194-3.501s3.605-.207 5.442 2.496c0 0 1.039-3.119 3.951-3.258l-2.403 3.651s2.403-1.225 5.731-.15l-4.957 1.318s2.773.277 3.917 4.333l-4.298-2.946s1.318 1.56.832 4.61l-2.357-5.098zm-50.993-33.816-9.762-4.881 7.1 8.874h3.993z" />
      </g>
      <path
        d="m262.94 142.978 26.337-8.104-13.981-5.242a22.157 22.157 0 0 0-7.789-1.412h-2.633a2.218 2.218 0 0 0-2.218 2.218v2.218h-13.312v-2.218a2.218 2.218 0 0 0-2.218-2.218h-2.633c-2.66 0-5.299.479-7.789 1.412l-13.981 5.242 26.337 8.104a2.22 2.22 0 0 1 1.332 3.113l-3.266 6.531h17.748l-3.266-6.531a2.219 2.219 0 0 1 1.332-3.113z"
        fill="#825546"
      />
      <circle fill="#F5F5F5" cx={255.999} cy={134.875} r={4.436} />
      <path
        d="M258.218 134.875a2.218 2.218 0 0 1-2.218 2.218h-8.874l3.787-3.787c.416-.416.98-.65 1.569-.65h3.517a2.22 2.22 0 0 1 2.219 2.219z"
        fill="#FFBE5A"
      />
    </g>
  </svg>
);
export default SvgBo;
